import React, { useEffect, useRef, useState } from 'react';

export const fitDocumentScale = (width, pageWidth = 794, zoom = 1) => Math.min(1, Math.max(1, width) / pageWidth) * zoom;

export default function DocumentViewport({ html, zoom = 1 }) {
    const viewportRef = useRef(null);
    const frameRef = useRef(null);
    const [width, setWidth] = useState(794);
    const [page, setPage] = useState({ width:794, height:1123 });
    useEffect(() => {
        const viewport = viewportRef.current;
        const measure = () => setWidth(Math.max(1, viewport.clientWidth - 20));
        measure();
        const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
        observer?.observe(viewport);
        window.addEventListener('resize', measure);
        return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
    }, []);
    useEffect(() => {
        const frame = frameRef.current;
        const doc = frame?.contentDocument;
        if (!frame || !doc) return undefined;
        let active = true;
        let observer;
        const measure = () => {
            if (active) {
                const width = Math.max(794, doc.body.scrollWidth);
                const height = Math.max(1123, doc.body.scrollHeight);
                setPage(previous => previous.width === width && previous.height === height ? previous : {width,height});
            }
        };
        const loaded = () => {
            doc.body.style.setProperty('padding','0','important');
            doc.body.style.setProperty('margin','0','important');
            measure();
            doc.fonts?.ready.then(measure).catch(() => null);
            observer?.disconnect();
            observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
            observer?.observe(doc.body);
        };
        frame.addEventListener('load', loaded);
        // Fixed layout dimensions precede fitting; global iframe max-width must not shrink it twice.
        for (const property of ['width','min-width','max-width']) frame.style.setProperty(property,'794px','important');
        frame.style.setProperty('height','1123px','important');
        doc.open(); doc.write(html); doc.close();
        loaded();
        return () => { active=false; observer?.disconnect(); frame.removeEventListener('load',loaded); };
    }, [html]);
    const scale = fitDocumentScale(width, page.width, zoom);
    useEffect(() => {
        for (const property of ['width','min-width','max-width']) frameRef.current.style.setProperty(property,`${page.width}px`,'important');
        frameRef.current.style.setProperty('height',`${page.height}px`,'important');
    }, [page.width,page.height]);
    return <div ref={viewportRef} className="document-preview-viewport" data-testid="quick-print-preview-panel">
        <div className="document-page-size" style={{width:page.width*scale,height:page.height*scale}}>
            <iframe ref={frameRef} title="معاينة المستند" sandbox="allow-same-origin" className="document-page-frame"
                style={{transform:`scale(${scale})`}} data-testid="quick-print-preview" />
        </div>
    </div>;
}
